
export const windowClarity = (pageName='') => {
    if (window.hasOwnProperty('clarity')) {
        window.clarity("identify", window.user_email, window.domain, pageName);
    }
}
